import { defineStore } from "pinia";
const useProductBuyBoxStore = defineStore("productBuyBoxStore", {
  state() {
    return {
      selectedColor: void 0,
      selectedSize: void 0,
      selectedSku: void 0,
      tempColor: void 0,
      quantity: 1
    };
  },
  actions: {
    handleColorChange(data) {
      this.selectedColor = data.color;
    },
    handleSizeChange(data) {
      this.selectedSize = data.newSize;
    }
  },
  getters: {}
});
export {
  useProductBuyBoxStore as default
};
//# sourceMappingURL=productBuyBoxStore.mjs.map
